import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createIngreso, updateIngreso, fetchIngreso } from '../actions/ingresoActions';
import { fetchTiposIngreso } from '../actions/tipoIngresoActions';
import { fetchSocios } from '../actions/socioActions';
import { Modal, Form, Button, Table, Row, Col, Spinner, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import ReciboModal from './ReciboModal';

const IngresoForm = ({ show, handleClose, isEdit, ingresoId }) => {
    // ConfiguraciÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â³n inicial
    moment.tz.setDefault('America/La_Paz');
    const dispatch = useDispatch();
    const { currentIngreso } = useSelector(state => state.ingreso);
    const { tiposIngreso } = useSelector(state => state.tipoIngreso);
    const { socios } = useSelector(state => state.socio);

    // Estados principales
    const [ingreso, setIngreso] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [editDetalleIndex, setEditDetalleIndex] = useState(null);
    const [showReciboModal, setShowReciboModal] = useState(false);
    const [showSociosModal, setShowSociosModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    // Estados del formulario
    const [formData, setFormData] = useState({
        nrorec: '',
        beneficiario: '',
        socioId: '',
        concepto: '',
        docum: '',
        fecha: moment().tz('America/La_Paz').format('YYYY-MM-DD'),
        monto: 0,
        tipo: 'INGRESO',
        detalles: []
    });

    const [detalleTemp, setDetalleTemp] = useState({
        tipoIngresoId: '',
        concepto: '',
        monto: 1,
        observaciones: ''
    });

    const [reciboData, setReciboData] = useState({
        nroRecibo: '',
        fechaPago: new Date(),
        beneficiario: '',
        concepto: '',
        detalles: [],
        total: 0
    });

    // Cargar datos iniciales
    useEffect(() => {
        dispatch(fetchTiposIngreso());
        dispatch(fetchSocios());
    }, [dispatch]);

    // Resetear formulario
    const resetForm = useCallback(() => {
        setFormData({
            nrorec: '',
            beneficiario: '',
            socioId: '',
            concepto: '',
            docum: '',
            fecha: moment().tz('America/La_Paz').format('YYYY-MM-DD'),
            monto: 0,
            tipo: 'INGRESO',
            detalles: []
        });
        setDetalleTemp({
            tipoIngresoId: '',
            concepto: '',
            monto: 1,
            observaciones: ''
        });
        setEditDetalleIndex(null);
        setIsReadOnly(false);
    }, []);

    // Cargar datos del ingreso para ediciÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â³n
    const loadIngresoData = useCallback(async () => {
        if (!isEdit || !ingresoId) return;
        
        setIsLoading(true);
        try {
            const response = await dispatch(fetchIngreso(ingresoId));
            const ingresoData = response.payload;
            
            setIngreso(ingresoData);
            setIsReadOnly(true);
            
            setFormData({
                nrorec: ingresoData.nrorec || '',
                beneficiario: ingresoData.beneficiario || '',
                socioId: ingresoData.socioId || '',
                concepto: ingresoData.concepto || '',
                docum: ingresoData.docum || '',
                fecha: ingresoData.fecha 
                    ? moment(ingresoData.fecha).tz('America/La_Paz').format('YYYY-MM-DD') 
                    : moment().tz('America/La_Paz').format('YYYY-MM-DD'),
                monto: ingresoData.monto || 0,
                tipo: ingresoData.tipo || 'INGRESO',
                detalles: ingresoData.detalles ? [...ingresoData.detalles] : []
            });
        } catch (error) {
            toast.error('Error al cargar el ingreso');
            handleClose();
        } finally {
            setIsLoading(false);
        }
    }, [dispatch, isEdit, ingresoId, handleClose]);

    // Efecto para cargar datos al abrir el modal
    useEffect(() => {
        if (!show) return;
        if (isEdit && ingresoId) {
            loadIngresoData();
        } else {
            resetForm();
        }
    }, [show, isEdit, ingresoId, loadIngresoData, resetForm]);

    // Filtrar socios basado en busqueda
    const normalizeText = (value) => (value || '').toString().toLowerCase();
    const filteredSocios = socios.filter(socio => {
        const nombreCompleto = [socio.nombres, socio.apPat, socio.apMat].filter(Boolean).join(' ');
        const term = normalizeText(searchTerm);
        return normalizeText(nombreCompleto).includes(term) || normalizeText(socio.ci).includes(term);
    });

    // Seleccionar socio como beneficiario
    const handleSelectSocio = (socio) => {
        setFormData({
            ...formData,
            beneficiario: `${socio.nombres} ${socio.apPat} ${socio.apMat}`,
            socioId: socio.id
        });
        setShowSociosModal(false);
        setSearchTerm('');
    };

    // Handlers del formulario
    const handleCabeceraChange = (e) => {
        if (isReadOnly) return;
        const { name, value } = e.target;
        setFormData({ 
            ...formData, 
            [name]: name === 'monto' ? Number(value) || 0 : value 
        });
    };

    const handleDetalleChange = (e) => {
        if (isReadOnly) return;
        const { name, value } = e.target;
        setDetalleTemp({ 
            ...detalleTemp, 
            [name]: name === 'monto' ? Number(value) || 0 : value 
        });
    };

    const handleTipoIngresoChange = (e) => {
        if (isReadOnly) return;
        const tipoId = e.target.value;
        const tipoSelected = tiposIngreso.find(t => t.id == tipoId);
        if (tipoSelected) {
            setDetalleTemp({
                ...detalleTemp,
                tipoIngresoId: tipoId,
                concepto: tipoSelected.nombre,
                monto: Number(tipoSelected.montoref) || 0
            });
        }
    };

    const handleAddDetalle = () => {
        if (isReadOnly) return;
    
        // ValidaciÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â³n de campos requeridos
        if (!detalleTemp.concepto || detalleTemp.monto <= 0) {
            toast.error('Complete concepto y monto vÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¡lido del detalle');
            return;
        }
    
        // Crear una copia de los detalles actuales
        const nuevosDetalles = [...formData.detalles];
    
        // Actualizar o agregar el detalle temporal
        if (editDetalleIndex !== null) {
            nuevosDetalles[editDetalleIndex] = detalleTemp;
        } else {
            nuevosDetalles.push(detalleTemp);
        }
    
        // Calcular el monto total correctamente
        const montoTotal = nuevosDetalles.reduce((sum, det) => {
            const montoNumerico = Number(det.monto) || 0; // Convertir a nÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Âºmero y manejar valores invÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¡lidos
            return sum + montoNumerico;
        }, 0);
    
        // Actualizar el estado con los nuevos detalles y el monto total
        setFormData({
            ...formData,
            detalles: nuevosDetalles,
            monto: montoTotal // Asignar el monto calculado
        });
    
        // Resetear el formulario de detalle
        resetDetalleForm();
    };

    const resetDetalleForm = () => {
        setDetalleTemp({
            tipoIngresoId: '',
            concepto: '',
            monto: 1,
            observaciones: ''
        });
        setEditDetalleIndex(null);
    };

    const handleEditDetalle = (index) => {
        if (isReadOnly) return;
        const detalle = formData.detalles[index];
        setDetalleTemp(detalle);
        setEditDetalleIndex(index);
    };

    const handleDeleteDetalle = (index) => {
        if (isReadOnly) return;
        const nuevosDetalles = formData.detalles.filter((_, i) => i !== index);
        const total = nuevosDetalles.reduce(
            (sum, det) => sum + (Number(det.monto) || 0),
            0
        );
        
        setFormData({
            ...formData,
            detalles: nuevosDetalles,
            monto: total
        });
    };

    const handlePrint = () => {
        if (!ingreso) return;
        
        setReciboData({
            nroRecibo: ingreso.nrorec,
            fechaPago: new Date(ingreso.fecha),
            beneficiario: ingreso.beneficiario,
            concepto: ingreso.concepto,
            detalles: ingreso.detalles,
            total: ingreso.monto
        });
        setShowReciboModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isReadOnly) {
            handleClose();
            return;
        }

        if (!formData.beneficiario || !formData.concepto || !formData.fecha || formData.detalles.length === 0) {
            toast.error('Complete beneficiario, concepto, fecha y agregue al menos un detalle');
            return;
        }

        try {
            setIsLoading(true);
            const action = isEdit ? updateIngreso(ingresoId, formData) : createIngreso(formData);
            const response = await dispatch(action);
            
            const ingresoGuardado = response.payload || {};
            
            toast.success(`Ingreso ${isEdit ? 'actualizado' : 'creado'} correctamente`);
            
            if (!isEdit && ingresoGuardado.nrorec) {
                setReciboData({
                    nroRecibo: ingresoGuardado.nrorec,
                    fechaPago: new Date(formData.fecha),
                    beneficiario: formData.beneficiario,
                    concepto: formData.concepto,
                    detalles: formData.detalles,
                    total: formData.monto
                });
                setShowReciboModal(true);
            } else {
                handleClose();
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <Modal show={show} onHide={handleClose} size="xl" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Editando Ingreso...' : 'Creando Ingreso...'}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                    <p>{isEdit ? 'Cargando datos del ingreso...' : 'Guardando ingreso...'}</p>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} size="xl" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Ver/Editar Ingreso' : 'Nuevo Ingreso'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={5}>
                                <Form.Group>
                                    <Form.Label>Beneficiario *</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="beneficiario"
                                            value={formData.beneficiario}
                                            onChange={handleCabeceraChange}
                                            required
                                            readOnly={isReadOnly}
                                        />
                                        {!isReadOnly && (
                                            <Button 
                                                type="button"
                                                variant="outline-secondary" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setShowSociosModal(true);
                                                }}
                                            >
                                                <i className="bi bi-search"></i> Buscar Socio
                                            </Button>
                                        )}
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={5}>
                                <Form.Group>
                                    <Form.Label>Concepto *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="concepto"
                                        value={formData.concepto}
                                        onChange={handleCabeceraChange}
                                        required
                                        readOnly={isReadOnly}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Fecha *</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="fecha"
                                        value={formData.fecha}
                                        onChange={handleCabeceraChange}
                                        required
                                        readOnly={isReadOnly}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {!isReadOnly && (
                            <>
                                <h5 className="mt-4">Detalles del Ingreso</h5>
                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Tipo de Ingreso</Form.Label>
                                            <Form.Select
                                                name="tipoIngresoId"
                                                value={detalleTemp.tipoIngresoId}
                                                onChange={handleTipoIngresoChange}
                                                disabled={isReadOnly}
                                            >
                                                <option value="">Seleccione...</option>
                                                {tiposIngreso.map(tipo => (
                                                    <option key={tipo.id} value={tipo.id}>
                                                        {tipo.nombre} (${(Number(tipo.montoref) || 0).toFixed(2)})
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Monto *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="monto"
                                                value={detalleTemp.monto}
                                                onChange={handleDetalleChange}
                                                min="0.01"
                                                step="0.01"
                                                required
                                                disabled={isReadOnly}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Observaciones</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="observaciones"
                                                value={detalleTemp.observaciones}
                                                onChange={handleDetalleChange}
                                                disabled={isReadOnly}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={1} className="d-flex align-items-end">
                                        <Button 
                                            type="button"
                                            variant={editDetalleIndex !== null ? "warning" : "primary"} 
                                            onClick={handleAddDetalle}
                                            disabled={isReadOnly}
                                        >
                                            {editDetalleIndex !== null ? 'Actualizar' : 'Agregar'}
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )}

                        <Table striped hover className="mt-3">
                            <thead>
                                <tr>
                                  
                                    <th>Concepto</th>
                                    <th>Monto</th>
                                    <th>Observaciones</th>
                                    {!isReadOnly && <th>Acciones</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {formData.detalles.map((detalle, index) => {
                                    const tipo = tiposIngreso.find(t => t.id == detalle.tipoIngresoId);
                                    return (
                                        <tr key={index}>
                                           
                                            <td>{detalle.concepto}</td>
                                            <td>${(Number(detalle.monto) || 0).toFixed(2)}</td>
                                            <td>{detalle.observaciones}</td>
                                            {!isReadOnly && (
                                                <td>
                                                    <Button 
                                                        type="button"
                                                        variant="outline-primary" 
                                                        size="sm" 
                                                        onClick={() => handleEditDetalle(index)}
                                                        className="me-2"
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </Button>
                                                    <Button 
                                                        type="button"
                                                        variant="outline-danger" 
                                                        size="sm"
                                                        onClick={() => handleDeleteDetalle(index)}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </Button>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>

                        <Row className="mt-4">
                            <Col md={{ span: 3, offset: 8 }}>
                                <h5>Total: ${Number(formData.monto).toFixed(2)}</h5>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-4">
                            {isReadOnly && (
                                <Button type="button" variant="info" onClick={handlePrint} className="me-2">
                                    <i className="bi bi-printer"></i> Imprimir
                                </Button>
                            )}
                            <Button type="button" variant="secondary" onClick={handleClose} className="me-2">
                                {isReadOnly ? 'Cerrar' : 'Cancelar'}
                            </Button>
                            {!isReadOnly && (
                                <Button variant="primary" type="submit" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            {isEdit ? 'Actualizando...' : 'Guardando...'}
                                        </>
                                    ) : (
                                        isEdit ? 'Actualizar Ingreso' : 'Guardar Ingreso'
                                    )}
                                </Button>
                            )}
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal para selecciÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â³n de socios */}
            <Modal show={showSociosModal} onHide={() => setShowSociosModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar Socio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Buscar socio por nombre o CI"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Form.Group>
                    <Table striped hover>
                        <thead>
                            <tr>
                                <th>Nombre Completo</th>
                                <th>CI</th>
                                <th>AcciÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â³n</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSocios.map(socio => (
                                <tr key={socio.id}>
                                    <td>{`${socio.nombres} ${socio.apPat} ${socio.apMat}`}</td>
                                    <td>{socio.ci}</td>
                                    <td>
                                        <Button 
                                            type="button"
                                            variant="primary" 
                                            size="sm"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleSelectSocio(socio);
                                            }}
                                        >
                                            Seleccionar
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>

            <ReciboModal
                show={showReciboModal}
                handleClose={() => {
                    setShowReciboModal(false);
                    handleClose();
                }}
                nroRecibo={reciboData.nroRecibo}
                data={reciboData}
            />
        </>
    );
};

export default IngresoForm;
